<template>
    <BaseForm v-if="project && errors">
        <template #fields>
            <PresetTextField
                :value="values.companyGroup"
                :presets="COMPANY_GROUP_PRESETS"
                :label="$t('company-group')"
                :error-messages="errors.companyGroup"
                @input="setFieldValue('companyGroup', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('companyGroup', true)"
            />
            <TextField
                :value="values.businessDomain"
                :label="$t('business-domain')"
                :error-messages="errors.businessDomain"
                @input="setFieldValue('businessDomain', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('businessDomain', true)"
            />
            <TextField
                :value="values.department"
                :label="$t('department')"
                :error-messages="errors.department"
                @input="setFieldValue('department', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('department', true)"
            />
            <TextAreaField
                :value="values.organisationalChanges"
                :label="$t('organisational-changes')"
                :error-messages="errors.organisationalChanges"
                :max-length="ProjectSeriesOrgSchema.shape.organisationalChanges.maxLength ?? undefined"
                @input="setFieldValue('organisationalChanges', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('organisationalChanges', true)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { COMPANY_GROUP_PRESETS } from '@/components/Form/defaults';
import PresetTextField from '@/components/Form/PresetTextField.vue';
import TextAreaField from '@/components/Form/TextAreaField.vue';
import TextField from '@/components/Form/TextField.vue';
import { useForm } from '@/forms/composables/useForm';
import { useProjectInjection } from '@/project/composables/useProjectInjection';
import { ProjectOrgSchema, ProjectSeriesOrgSchema } from '@/project/schemas';
import { computed } from 'vue';

const props = defineProps<{ projectId: string }>();

const projectId = computed(() => props.projectId);

const { project, updateProject } = useProjectInjection();

const { values, errors, setFieldValue, setFieldTouched, validate, onDiscard, resetForm } = useForm(
    ProjectOrgSchema,
    computed(() => ({
        companyGroup: project.value?.companyGroup ?? '',
        businessDomain: project.value?.businessDomain ?? '',
        department: project.value?.businessDomain ?? '',
        organisationalChanges: project.value?.businessDomain ?? '',
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await updateProject({ id: projectId.value, ...values.value });
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
